import { InputWrapper, PasswordInput, Tooltip, ActionIcon } from '@mantine/core'
import { ArrowRight } from 'lucide-react'

import { navigate, routes } from '@redwoodjs/router'

import DateInput from 'src/components/Inputs/DateInput/DateInput'
import IconAlertCircle from 'src/icons/IconAlertCircle'

const namesMatch = (
  driverName: string,
  firstName: string,
  lastName: string
) => {
  const normalizedDriverName = driverName?.toLowerCase().trim()
  const normalizedApplicantName = `${firstName} ${lastName}`
    .toLowerCase()
    .trim()
  return normalizedDriverName === normalizedApplicantName
}

const DriverInfoCard = ({ voe, noApplicantLink, showNameMismatchCheck = true, hideSsn = false }) => {
  const showNameMismatch =
    showNameMismatchCheck &&
    voe.driverName &&
    voe.applicant &&
    !namesMatch(voe.driverName, voe.applicant.firstName, voe.applicant.lastName)
  return (
    <div className="flex flex-col gap-6 rounded-lg border border-doubleNickel-gray-200">
      <div className="flex flex-col gap-6 p-6">
        <div className="text-md font-semibold text-doubleNickel-gray-900">
          Driver Information
        </div>
        <div className="flex flex-row justify-between gap-4">
          <InputWrapper
            label="Driver Name"
            classNames={{
              root: 'flex flex-col flex-1 items-start',
              label: 'text-xs font-medium text-doubleNickel-gray-700',
            }}
          >
            <div className="flex flex-col gap-1 py-2">
              <div className="flex flex-row items-center gap-2">
                <span className="text-sm text-doubleNickel-gray-900">
                  {voe.driverName || (voe.applicant ? `${voe.applicant.firstName} ${voe.applicant.lastName}` : 'N/A')}
                </span>
                {voe.applicant && !noApplicantLink && (
                  <Tooltip label="Go to profile">
                    <ActionIcon
                      variant="subtle"
                      size="sm"
                      onClick={() => {
                        navigate(
                          routes.applicantDetails({
                            id: voe.applicant.applicantId,
                            tab: 'application',
                          })
                        )
                      }}
                    >
                      <ArrowRight
                        size={16}
                        className="stroke-doubleNickel-brand-500"
                      />
                    </ActionIcon>
                  </Tooltip>
                )}
              </div>
              {showNameMismatch && (
                <div className="flex items-center gap-1.5 rounded-md bg-doubleNickel-warning-50 px-2 py-1.5 border border-doubleNickel-warning-200">
                  <IconAlertCircle
                    className="h-3.5 w-3.5 shrink-0 stroke-doubleNickel-warning-600"
                    stroke="currentColor"
                    fill="none"
                  />
                  <span className="text-xs text-doubleNickel-warning-700">
                    <span className="font-medium">Name mismatch:</span> Matches applicant &ldquo;
                    {voe.applicant.firstName} {voe.applicant.lastName}&rdquo;
                  </span>
                </div>
              )}
            </div>
          </InputWrapper>

          {!hideSsn && (
            <PasswordInput
              label="SSN"
              className="flex-1"
              value={voe.ssn}
              variant="unstyled"
              classNames={{
                label: 'text-xs font-medium text-doubleNickel-gray-700',
              }}
              readOnly
            />
          )}

          <DateInput
            label="Date of Birth"
            className="flex-1"
            value={new Date(voe.dob)}
            editing={false}
          />
        </div>
      </div>
    </div>
  )
}

export default DriverInfoCard
